import { apiClient, Pagination, PaginationSearchParams } from '@/shared/api'

import { TArticle, TArticleCategory } from '../model/schema'

export type GetArticlesParams = PaginationSearchParams & {
  categoryId?: number
  onlyGuestArticle?: boolean
  onlyHostArticle?: boolean
}

type GetArticlesResponse = {
  articles: Pagination<TArticle>
  articleCategories: TArticleCategory[]
}

export const getArticles = async (params: GetArticlesParams = {}) => {
  const response = await apiClient.get<GetArticlesResponse>({
    endpoint: '/campaigns/articles',
    queryParams: {
      ...params,
      size: 10,
    },
  })

  return response
}
